import React, {useEffect,useState,createContext, useCallback, useRef} from 'react'
import { setToken, getToken, removeToken } from '../api/Common/token';
import { removeNotification } from '../api/Common/report';
import { useUser } from '../hooks';
import { STORAGE_KEYS } from '../utils/constantes';
export const AuthContext = createContext({
    auth: undefined,
    login :()=>null,
    logout:()=>null
});

export function AuthProvider(props){
    const {children} = props
    const [auth,setAuth] = useState(undefined)
    const {getMe} = useUser()
    const getMeRef = useRef(getMe);
    
    // Mantener referencia actualizada de getMe
    useEffect(() => {
        getMeRef.current = getMe;
    }, [getMe]);

    useEffect(()=>{
            (async()=>{
                try {
                    const token = getToken()

                    if(token){
                        const me = await getMeRef.current(token)

                        if(!me)
                            setAuth(null)
                        else
                            setAuth({token,me}) 
                    }else{
                        setAuth(null)
                    }
                } catch (error) {
                    console.error("Error al verificar autenticación:", error);
                    setAuth(null);
                }
            })()
    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    const login = useCallback(async (token)=>{
        try {
            setToken(token)
            const me = await getMeRef.current(token)
            if(!me)
                setAuth(null)
            else
                setAuth({token,me})
        } catch (error) {
            console.error("Error en login:", error);
            setAuth(null);
            throw error;
        }
    }, [])

    const logout = useCallback(() =>{
        setAuth(null)
        removeToken()
        removeNotification()
        try {
            sessionStorage.removeItem(STORAGE_KEYS.CHAT_MENSAJES)
        } catch (error) {
            // storage deshabilitado: no hay nada que limpiar
        }
    }, [])

    const valueContext = {
        auth,
        login,
        logout
    }

    if (auth === undefined ) return null
    return (
        <AuthContext.Provider value={valueContext}>
            {children}
        </AuthContext.Provider>
    )
}